import React, { useContext, useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import BigNumber from 'bignumber.js';
import confetti from 'canvas-confetti';

import { nftName } from '../../utils/nft';

import NftNav from './components/NftNav';
import NftCard from './components/NftCard';
import NftInfo from './components/NftInfo';

import { fetchNftAirdrop, claimNftAirdrop } from '../../blockchain/nft';

import { WalletContext } from '../../context/wallet';
import { ToastContext } from '../../context/toast';

const NftAirdropPage = () => {
  const { walletAddress, handleConnectClick } = useContext(WalletContext);
  const { addToast } = useContext(ToastContext);

  const [pendingTx, setPendingTx] = useState(false);
  const [started, setStarted] = useState(false);
  const [nftAirdropState, setNftAirdropState] = useState({
    startTime: 0,
    userCanClaim: false,
    firstLoad: true,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    document.getElementById('bg').style.backgroundImage = 'url(/images/bg/bg-2.png)';

    return () => document.getElementById('bg').style.backgroundImage = null;
  }, []);

  useEffect(() => {
    const syncNftAirdrop = async () => {
      const rs = await fetchNftAirdrop();
      setNftAirdropState(prevState => ({ ...prevState, ...rs, firstLoad: false }));
    }

    const intervalId = setInterval(syncNftAirdrop, 5000);

    syncNftAirdrop();

    return () => clearInterval(intervalId);
  }, [setNftAirdropState]);

  useEffect(() => {
    const updateTimes = () => {
      const currentTime = Date.now() / 1000;
      const ss = new BigNumber(nftAirdropState.startTime);

      setStarted(prevState => prevState || (ss.gt(0) && ss.lt(currentTime)));
    }

    const intervalId = setInterval(updateTimes, 1000);

    updateTimes();

    return () => clearInterval(intervalId);
  }, [nftAirdropState.startTime, setStarted]);

  const showConfetti = () => {
    confetti({
      resize: true,
      particleCount: 200,
      startVelocity: 30,
      gravity: 0.5,
      spread: 350,
      origin: {
        x: 0.5,
        y: 0.3,
      },
    });
  }

  const handleClaimNft = async () => {
    let tx;
    try {
      setPendingTx(true);
      tx = await claimNftAirdrop();
      await tx.wait();
      addToast('NFT Airdrop claim succeeded', 'is-success');
      showConfetti();
    } catch (error) {
      tx = { error: error.data?.message || error.message };
    }

    if(tx?.error !== undefined) {
      console.log('error', tx.error);
      addToast('NFT Airdrop claim failed', 'is-danger');
    }

    setPendingTx(false);
  }

  const renderApproveOrClaimButton = () => {
    if (walletAddress === null) {
      return (
        <button className="button is-primary is-fullwidth" onClick={ handleConnectClick }>
          Unlock
        </button>
      );
    }

    return (
      <button
        disabled={ pendingTx || !nftAirdropState.userCanClaim || !started }
        type="button"
        className={ `button is-primary is-fullwidth ${pendingTx ? 'is-loading' : ''}` }
        onClick={ handleClaimNft }
      >
        CLAIM
      </button>
    );
  }

  return (
    <>
      <NftNav />
      <header className="hero is-small" style={{ backgroundColor: 'transparent' }}>
        <div className="hero-body">
          <div className="container has-text-centered">
            <p className="title is-size-1 neon-success">NFT Cards Airdrop</p>
            <p className="subtitle is-size-3"><span className="has-text-success">NFT Cards</span> power will be unique and generated randomly.</p>
          </div>
        </div>
      </header>
      <main role="main" className="section">
        <div className="container">
          <div className="columns is-multiline is-justify-content-center">
            <div className="column is-half-desktop">
              <div className="box mb-5">
                { renderApproveOrClaimButton() }
                <hr />
                { !nftAirdropState.firstLoad && !started ? (
                  <p className="subtitle has-text-centered">
                    <span className="mr-1">Countdown until Start</span> <Countdown date={ new BigNumber(nftAirdropState.startTime).times(1000).toNumber() } />
                  </p>
                ) : null}
              </div>
              {started && !nftAirdropState.userCanClaim ? (
                <div className="notification is-danger is-light mb-3">
                  * Your address in unreachable in the top 50 holders or your NFT was already claimed.
                </div>
              ) : null}
              <NftInfo />
            </div>
            <div className="column is-one-quarter">
              <NftCard nftData={{
                pid: 2110,
                name: nftName({ generation: 5, pid: 2110 }),
                experience: 1920,
                generation: 5,
                boostStake: 2.87
              }} />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default NftAirdropPage;
